module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-22-53f70b42f666c01a0ae47d2b60b90fd9.svg";